/* eslint-disable default-case */
import React from "react";
import Calculator from "./components/Calculator";
import "./styles/App.css";
import { Navigate, Outlet, useRoutes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { Container } from "@mui/material";
import theme from "./theme";
import "./fonts.css";
import ResponsiveAppBar from "./components/TopBar";
import {
  AuthContext,
  DialogContext,
  JoySnackBarContext,
  TranslationContext,
} from "./components/context";
import TermsAndConditions from "./views/TermsAndConditions";
import PrivacyPolicy from "./views/PrivacyPolicy";
import CancellationAndRefundPolicy from "./views/CancellationAndRefundPolicy";
import PurchaseHistory from "./views/PurchaseHistory";
import SavedCharts from "./views/SavedCharts";
import About from "./views/About";
import Theory from "./views/Theory";
import Support from "./views/Support";
import { Box } from "@mui/material";
import SignInDialog from "./components/SignIn";
import ForgotPasswordDialog from "./components/ForgotPassword";
import SignUpDialog from "./components/SignUp";
import Profile from "./views/Profile";
import Account from "./views/Account";
import Dashboard from "./views/Dashboard";
import AllChartsDB from "./views/AllChartsDB";
import UrgentRequests from "./views/UrgentRequests";
import Users from "./views/Users";
import AdminSettings from "./views/AdminSettings";
import ContactUsForm from "./views/ContactUs";
import ShippingAndDelivery from "./views/ShippingAndDelivery";
import JoySnackBar from "./components/JoySnackBar";
import UnderDevelopmentNotice from "./components/UnderDevelopmentNotice";
import { useTranslation } from "react-i18next";
import GlobalState from "./contexts/globalstate";
import LandingPage from "./components/LandingPage";
import { DivisionalDirectory } from "./views/blogs/divisionalsFromD1/directory";
import ProjectInfo from "./views/ProjectInfo";
const isUnderDevelopment = false;

// https://production.d3acumx2i6pmcr.amplifyapp.com/
const routes = (authState) => [
  {
    path: "/",
    element:
      authState && "userId" in authState ? (
        <Outlet />
      ) : (
        <Navigate to="/welcome" />
      ),
    children: [
      { path: "/", element: <Navigate to="/interactive-kundali" /> },

      { path: "/support", element: <Support /> },
      { path: "/saved-charts", element: <SavedCharts /> },
      { path: "/purchase-history", element: <PurchaseHistory /> },
      { path: "/profile", element: <Profile /> },
      { path: "/account", element: <Account /> },

      { path: "/dashboard", element: <Dashboard /> },
      { path: "/all-charts-db", element: <AllChartsDB /> },
      { path: "/urgent-requests", element: <UrgentRequests /> },
      { path: "/user-list", element: <Users /> },
      { path: "/admin-settings", element: <AdminSettings /> },
    ],
  },
  {
    path: "/",
    element:
      !authState || !("userId" in authState) ? <Outlet /> : <Navigate to="/" />,
    children: [
      {
        path: "/welcome",
        element: (
          <>
            <Container maxWidth={false}>
              {
                <>
                  {isUnderDevelopment && <UnderDevelopmentNotice />}

                  {/* <Calculator /> */}
                </>
              }
            </Container>
            <LandingPage />
          </>
        ),
      },
      { path: "/", element: <Navigate to="/welcome" /> },
    ],
  },
  {
    path: "/interactive-kundali",
    element: (
      <>
        <Container maxWidth={false}>
          {
            <>
              {isUnderDevelopment && <UnderDevelopmentNotice />}

              <Calculator />
            </>
          }
        </Container>
      </>
    ),
  },
  {
    path: "/terms-and-conditions",
    element: <TermsAndConditions />,
  },
  {
    path: "/shipping-and-delivery",
    element: <ShippingAndDelivery />,
  },
  {
    path: "/contact-us",
    element: <ContactUsForm />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/cancellation-and-refund-policy",
    element: <CancellationAndRefundPolicy />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/theory",
    element: <Theory />,
  },
  { path: "/project-astrodata", element: <ProjectInfo /> },
  ...DivisionalDirectory,
  {
    path: "*",
    element: <Navigate to="/" />,
  },
];

function App() {
  let localAuthState = localStorage.getItem("logged-state");
  localAuthState = localAuthState ? JSON.parse(localAuthState) : {};

  const [authState, setAuthState] = React.useState(localAuthState); // for local dev
  // const [authState, setAuthState] = React.useState(null);
  const [dialogData, setDialogData] = React.useState("");
  const [joySnackBarData, setJoySnackBarData] = React.useState({});

  const AuthDispatcher = (type, payload) => {
    switch (type) {
      case "LOGGED-IN":
        setAuthState(payload);
        localStorage.setItem("logged-state", JSON.stringify(payload)); // This is demo only step  or dev step
        return;
      case "LOGGED-OUT":
        setAuthState({});
        localStorage.removeItem("logged-state");
        localStorage.removeItem("cart");
        return;
    }
  };

  const DialogDispatcher = (type, payload) => {
    switch (type) {
      case "OPEN":
        setDialogData(payload);
        return;
      case "CLOSE":
        setDialogData(null);
        return;
    }
  };

  const JoySnackBarDispatcher = (type, payload) => {
    switch (type) {
      case "OPEN":
        setJoySnackBarData({ ...payload, open: true });
        return;
      case "CLOSE":
        setJoySnackBarData({ open: false });
        return;
      default:
        return;
    }
  };

  const routing = useRoutes(routes(authState));

  const { t } = useTranslation();

  return (
    <GlobalState>
      <TranslationContext.Provider value={t}>
        <AuthContext.Provider value={{ authState, AuthDispatcher }}>
          <DialogContext.Provider value={{ dialogData, DialogDispatcher }}>
            <JoySnackBarContext.Provider
              value={{ joySnackBarData, JoySnackBarDispatcher }}
            >
              <ThemeProvider theme={theme}>
                <CssBaseline />

                <Box
                  sx={{
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <ResponsiveAppBar />

                  {dialogData.login && (
                    <SignInDialog login={dialogData.login} />
                  )}
                  {dialogData.forgotPassword && (
                    <ForgotPasswordDialog
                      forgotPassword={dialogData.forgotPassword}
                    />
                  )}
                  {dialogData.signup && (
                    <SignUpDialog signup={dialogData.signup} />
                  )}

                  {routing}
                </Box>
              </ThemeProvider>
              {joySnackBarData.open && <JoySnackBar />}
            </JoySnackBarContext.Provider>
          </DialogContext.Provider>
        </AuthContext.Provider>
      </TranslationContext.Provider>
    </GlobalState>
  );
}

export default App;
